import { render, staticRenderFns } from "./GlobalCaching.vue?vue&type=template&id=6a68534a"
import script from "./GlobalCaching.vue?vue&type=script&lang=js"
export * from "./GlobalCaching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports